import { homeIcons } from '../../assets/images/home';

const AppSection = () => {
    return (
        <section id="app">
            <div className="content">
                <div className="title">
                    <h2>Télécharger Polyglow et  <span>briller</span> grâce aux <span>langues !</span></h2>
                </div>
                <div className="download">
                    <div className="google-play">
                        <a className="btn-dl" href="#"><img src={homeIcons.google} alt="Bouton Google Play"/></a>
                    </div>
                    <div className="app-store">
                        <a className="btn-dl" href="#"><img src={homeIcons.apple} alt="Bouton App Store"/></a>
                    </div>
                </div>
            </div>
        </section>
    );
};


export default AppSection;